import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Slider, Arrow, SanitizeHTML } from '@tc-packages/tc-common'

export default function IconsSection({ section }) {
  const {
    config: { is_gray },
    items,
    node_id,
  } = section

  const [slidesToShow, setSlidesToShow] = useState(4)

  useEffect(() => {
    const updateSlidesToShow = () => {
      const width = window.innerWidth
      if (width <= 767) {
        setSlidesToShow(1)
      } else if (width <= 991) {
        setSlidesToShow(3)
      } else {
        setSlidesToShow(4)
      }
    }

    updateSlidesToShow()
    window.addEventListener('resize', updateSlidesToShow)
    return () => window.removeEventListener('resize', updateSlidesToShow)
  }, [])

  const carouselControlsButtonStyles = {
    '--button-carousel-controls-background': '#1b8158',
    '--button-carousel-controls-background-hover': '#055f30',
    '--button-carousel-controls-color': '#ffffff',
    '--button-carousel-controls-color-hover': '#ffffff',
  }

  const carouselSettings = {
    slidesToScroll: 1,
    slidesToShow: 4,
    nextArrow: (
      <Arrow
        carouselControlsButtonStyles={carouselControlsButtonStyles}
        direction="next"
      />
    ),
    prevArrow: (
      <Arrow
        carouselControlsButtonStyles={carouselControlsButtonStyles}
        direction="prev"
      />
    ),
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 3, infinite: false },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 },
      },
    ],
    className: `simpleCards_row row simpleCardsIcon_withArrows iconCards_slider_${node_id}`,
  }

  const sliderItem = (item) => {
    return (
      <div className="simpleCardsIcon_item col-md-3" key={item.index}>
        <div className="simpleCardsIcon_content">
          <img
            alt={item.alt}
            className="simpleCardsIcon_icon"
            src={item.icon}
          />
          <h3 className="simpleCardsIcon_title">{item.title}</h3>
          <div className="simpleCardsIcon_text">
            <SanitizeHTML html={item.content} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <section className={is_gray ? 'section--grey' : ''} key={node_id}>
      <div className="container contentWrapper_large">
        {items.length > slidesToShow ? (
          <Slider
            items={items.map((item) => sliderItem(item))}
            {...carouselSettings}
          />
        ) : (
          <div className="simpleCards_row row simpleCardsIcon_withArrows iconCards_slider_static">
            {items.map((item) => sliderItem(item))}
          </div>
        )}
      </div>
    </section>
  )
}

IconsSection.propTypes = {
  section: PropTypes.shape({
    config: PropTypes.shape({
      is_gray: PropTypes.bool.isRequired,
    }).isRequired,
    items: PropTypes.array.isRequired,
    node_id: PropTypes.string.isRequired,
  }).isRequired,
}
